import http from "./httpService";
import { config } from "../config";
import { getIdentity } from "../components/common/commonFuncs";
////////////////////////////////////////////////////////////////
const prefix = "/api/v2/utils/";
const apiEndpoint = config.apiEndpoint;
////////////////////////////////////////////////////////////////

export function logActivity(page, action, otherInfo = null) {
  return http.post(apiEndpoint + prefix + "logActivity", {
    UserName: getIdentity(),
    Page_Visited: page,
    Page_Action: action,
    Browser: navigator.userAgent,
    Other_Info: otherInfo,
    Activity_By: getIdentity()
  });
}

export function getAppConfig() {
  return http.get(apiEndpoint + prefix + "getAppConfig", { params: { Activity_By: getIdentity() } });
}

export function updateAppConfig(state) {
  return http.post(apiEndpoint + prefix + "updateAppConfig", {
    Configuration_ID: state.Configuration_ID,
    Configuration_Name: state.Configuration_Name,
    Configuration_Description: state.Configuration_Description,
    Configuration_Value: state.Configuration_Value,
    Activity_By: getIdentity()
  });
}

export function deleteAppConfig(Configuration_ID) {
  return http.post(apiEndpoint + prefix + "deleteAppConfig", {
    Configuration_ID: Configuration_ID,
    Activity_By: getIdentity()
  });
}

export function lookupIP(){
  return http.get(apiEndpoint + prefix + "lookupIP", { params: { Activity_By: getIdentity() } });
}

export function execGenericSP(dataEl){
  return http.post(apiEndpoint + prefix + "execGenericSP", {
    ResultSource_Content : dataEl['ResultSource_Content'],
    Connection_String : dataEl['Connection_String'],
    Parameters : JSON.parse(dataEl['jsonParameters']),
    Activity_By: getIdentity()
  });
}